module.exports = __webpack_public_path__ + "img/pub_rec_home_final_960.81c969d6.png";